import { render, staticRenderFns } from "./zhuanzuoshangyouxia.vue?vue&type=template&id=5a43a006&scoped=true&"
import script from "./zhuanzuoshangyouxia.vue?vue&type=script&lang=js&"
export * from "./zhuanzuoshangyouxia.vue?vue&type=script&lang=js&"
import style0 from "./zhuanzuoshangyouxia.vue?vue&type=style&index=0&id=5a43a006&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43a006",
  null
  
)

export default component.exports